export * from './DocsPlusIcon';
export * from './DocsPlusIcon16Light';
export * from './DocsPlusIcon16Regular';
export * from './DocsPlusIcon16Solid';
export * from './DocsPlusIcon20Light';
export * from './DocsPlusIcon20Regular';
export * from './DocsPlusIcon20Solid';
export * from './DocsPlusIcon24Regular';
export * from './DocsPlusIcon24Solid';
export * from './DocsPlusIcon32Regular';
export * from './DocsPlusIcon64Regular';
